import { render, staticRenderFns } from "./NflBrowseTeam.vue?vue&type=template&id=2279f150&scoped=true"
import script from "./NflBrowseTeam.vue?vue&type=script&lang=js"
export * from "./NflBrowseTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279f150",
  null
  
)

export default component.exports